import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";

const cookies = new Cookies();
const proxy = GetProxy();

export const businessInfoList = createAsyncThunk(
  "post/businessInfoList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/businessInfoConfig/BusinessInfoConfigListAndCount/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const businessInfoCount = createAsyncThunk(
  "post/getDatas",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/businessInfoConfig/list/BusinessInfoConfigSearchCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const AppList = createAsyncThunk("post/getDatasApp", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { userName, userRole } = props;
    const response = await fetch(
      `${proxy}/api/v1/cmdb/${userName}/${userRole}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      }
    );
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("error:", error);
    throw error;
  }
});

export const BusinessInfoSave = createAsyncThunk("post/save", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { userName, payload } = props;

    const response = await fetch(
      `${proxy}/cmdb/api/v1/businessInfoConfig/saveOrUpdateBusinessConfigInfo/${userName}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const Businessdelete = createAsyncThunk(
  "post/deleteinfo",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { userName, id } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/businessInfoConfig/delete/${id}/${userName}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const BusinessEdit = createAsyncThunk(
  "post/getdataedit",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { id } = props;
      const response = await fetch(`${proxy}/api/v1/businessInfoConfig/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      });
      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);
export const getTableFilter = createAsyncThunk(
  "post/getTableFilter",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/businessInfoConfig/filter/divisionWithDepartments`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
);
export const userInfoListApi = createAsyncThunk(
  "post/userInfoListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/LDAPDashboard/UsersListWithCount/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userInfoCountApi = createAsyncThunk(
  "post/userInfoCountApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/LDAPDashboard/UserInfoForCmdbCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const serverInfoListApi = createAsyncThunk(
  "post/serverInfoListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/serverConfigInfo/getDeviceListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountListApi = createAsyncThunk(
  "post/cloudAccountListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/awsIam/getMasterCloudAccountsDetailsList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountCountApi = createAsyncThunk(
  "post/cloudAccountCountApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/awsIam/CSPAccountListForSearchCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountTestConnection = createAsyncThunk(
  "post/cloudAccountTestConnection",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      console.log(props);
      const response = await fetch(
        `${proxy}/cmdb/api/v1/awsIam/checkAccountForTestConnection`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const osLicenseConfigListApi = createAsyncThunk(
  "post/osLicenseConfigListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/licenceConfigForServerRest/getListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const osLicenseConfigCountApi = createAsyncThunk(
  "post/osLicenseConfigCountApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/licenceConfigForServerRest/getListCountWithSearchAndPagination`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const isLdapUserCheckAPI = createAsyncThunk(
  "post/isLdapUserCheckAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/LDAPDashboard/checkLDAPConfig`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const ldapSyncAPI = createAsyncThunk(
  "post/ldapSyncAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/LDAPDashboard/LDAPDashboardDataSave`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userSearchList = createAsyncThunk(
  "get/userSearchList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { cmdbId } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/UserAccessRest/usersList/${cmdbId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const saveReviewerConfiguration = createAsyncThunk(
  "post/saveReviewerConfiguration",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payLoad } = props;
      console.log(payLoad);
      const response = await fetch(
        `${proxy}/cmdb/api/v1/UserAccessRest/saveReviewConfig`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payLoad),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const reviewersList = createAsyncThunk(
  "get/reviewersList",
  async (props) => {
    const cmdbId = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/UserAccessRest/getReviewersByApplication/${cmdbId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const reviewConfiguration = createAsyncThunk(
  "get/reviewConfiguration",
  async (props) => {
    const cmdbId = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/UserAccessRest/getReviewConfigByApplication/${cmdbId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getServerConfigDetails = createAsyncThunk(
  "get/getServerConfigDetails",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    const { ip } = props;
    try {
      const response = await fetch(
        `${proxy}/api/v1/tenableAdvanceScan/getByIP/${ip}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const SaveServerConfig = createAsyncThunk(
  "post/SaveServerConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;

      const response = await fetch(
        `${proxy}/api/v1/tenableAdvanceScan/saveOrUpdate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getProjectList = createAsyncThunk(
  "get/getProjectList",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/jiraProjectListRest/list/jiraProjectList`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  }
);
export const getGitlabProjectList = createAsyncThunk(
  "get/getGitlabProjectList",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/gitlab/getGitlabProjects`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  }
);
export const getSonarProjectListAPI = createAsyncThunk(
  "get/getSonarProjectListAPI",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/jiraProjectListRest/list/sonarQubeProjectList`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  }
);

export const exportCmdbAppConfigCSV = createAsyncThunk(
  "post/exportCmdbAppConfigCSV",
  async (payload) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/cmdb/exportCmdbAppConfigCSV`,
        {
          method: "POST",
          headers: {
            Accept: "application/octet-stream",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      // handleResponseCode(response);
      const data = await response.blob();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const ImportCmdbDevices = createAsyncThunk(
  "post/ImportCmdbDevices",
  async ({ formData, url }, { rejectWithValue }) => {
    try {
      const apiToken = cookies.get("apitoken");
      const username = cookies.get("username");

      const response = await fetch(proxy + url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      console.error("Error:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const downloadTemplate = createAsyncThunk(
  "file/downloadTemplate",
  async (importTypeInteger, { rejectWithValue }) => {
    try {
      const apiToken = cookies.get("apitoken");
      const username = cookies.get("username");

      const isDevice = importTypeInteger === 0;

      const url = isDevice
        ? `${proxy}/cmdb/api/v1/serverConfigInfo/templateCSVForDevice`
        : `${proxy}/tenable/api/v1/assetConfiguration/templateCSVForAssetConfig`;

      const fileName = isDevice
        ? "devices_Template.csv"
        : "AssertConfiguration_Template.csv";

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/octet-stream",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      });

      if (!response.ok) {
        return rejectWithValue(`Error ${response.status}`);
      }

      const blob = await response.blob();

      // download inside thunk allowed
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);

      return { success: true };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const CMDBSlice = createSlice({
  name: "CmdbId",
  initialState: {
    getCmdbId: "",
    businessInfoData: [],
    bILoading: false,
    businessInfoDataCount: [],
    Applist: [],
    ApplistLoading: false,
    bICountLoading: false,
    saveLoading: false,
    DataSave: "",
    deleteLoading: false,
    editLoading: false,
    responseData: [],
    tableFilterData: [],
    error: "",
    errorEdit: "",
    errorCount: "",
    errorApp: "",
    errorSave: "",
    errorDelete: "",
    DataDelete: {},
    userInfoListLoading: false,
    userInfoListData: [],
    userInfoCountLoading: false,
    userInfoCountData: [],
    serverInfoListLoading: false,
    serverInfoListData: [],
    cloudAccountListLoading: false,
    cloudAccountListData: [],
    cloudAccountCountLoading: false,
    cloudAccountCountData: [],
    osLicenseConfigListLoading: false,
    osLicenseConfigListData: [],
    osLicenseConfigCountLoading: false,
    osLicenseConfigCountData: [],
    isLdapUser: false,
    isLdapUserLoading: false,
    ldapSyncdata: [],
    ldapSyncLoading: false,
    ldapSyncdataFulFill: false,
    alertError: false,
    userSearchListLoading: false,
    userSearchListData: [],
    saveReviewerConfigurationLoading: false,
    saveReviewerConfigurationData: [],
    reviewersListLoading: false,
    reviewersListData: [],
    reviewConfigurationLoading: false,
    reviewConfigurationData: [],
    serverConfigData: [],
    serverConfigLoading: false,
    serverConfogSaveData: [],
    serverConfigSaveDataLoading: false,
    projectListData: [],
    projectListDataLoading: false,
    GitlabprojectListData: [],
    GitlabprojectListDataLoading: false,
    getSonarProjectListData: [],
    getSonarProjectListLoading: false,
    exportCSVListLoading: false,
    exportCSVData: [],
    ImportCmdbDevicesData: [],
    ImportCmdbDevicesDataLoading: [],
    ImportCmdbDevicesError: "",
    templateLoading: false,
    templateError: "",
  },
  reducers: {
    setCmdbId: (state, action) => {
      state.getCmdbId = action.payload;
    },
    setalertError: (state, action) => {
      state.alertError = false;
    },
    resetDataSave: (state) => {
      state.DataSave = "";
    },
    resetldapSyncStatus: (state) => {
      state.ldapSyncdataFulFill = false;
      state.ldapSyncdata = "";
    },
    resetresponseData: (state) => {
      state.responseData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(businessInfoList.pending, (state, action) => {
        state.bILoading = true;
        state.alertError = false;
      })
      .addCase(businessInfoList.fulfilled, (state, action) => {
        state.businessInfoData = action.payload;
        state.bILoading = false;
        state.alertError = false;
      })
      .addCase(businessInfoList.rejected, (state, action) => {
        state.bILoading = false;
        state.businessInfoData = [];
        state.error = "Something went wrong";
        state.alertError = true;
      })

      .addCase(businessInfoCount.pending, (state, action) => {
        state.bICountLoading = true;
        state.alertError = false;
      })
      .addCase(businessInfoCount.fulfilled, (state, action) => {
        state.businessInfoDataCount = action.payload;
        state.bICountLoading = false;
        state.alertError = false;
      })
      .addCase(businessInfoCount.rejected, (state, action) => {
        state.bICountLoading = false;
        state.businessInfoDataCount = [];
        state.errorCount = "Something went wrong";
        state.alertError = true;
      })

      .addCase(AppList.pending, (state, action) => {
        state.ApplistLoading = true;
        state.alertError = false;
      })
      .addCase(AppList.fulfilled, (state, action) => {
        state.Applist = action.payload;
        state.ApplistLoading = false;
        state.alertError = false;
      })
      .addCase(AppList.rejected, (state, action) => {
        state.ApplistLoading = false;
        state.Applist = [];
        state.errorApp = "Something went wrong";
        state.alertError = true;
      })

      .addCase(BusinessInfoSave.pending, (state, action) => {
        state.DataSave = "";
        state.saveLoading = true;
        state.alertError = false;
      })
      .addCase(BusinessInfoSave.fulfilled, (state, action) => {
        state.DataSave = action.payload;
        state.saveLoading = false;
        state.alertError = false;
      })
      .addCase(BusinessInfoSave.rejected, (state, action) => {
        state.saveLoading = false;
        state.DataSave = "";
        state.errorSave = "Something went wrong";
        state.alertError = true;
      })

      .addCase(Businessdelete.pending, (state, action) => {
        state.deleteLoading = true;
        state.alertError = false;
      })
      .addCase(Businessdelete.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.DataDelete = action.payload;
        state.alertError = false;
      })
      .addCase(Businessdelete.rejected, (state, action) => {
        state.deleteLoading = false;
        state.errorDelete = "Something went wrong";
        state.alertError = true;
      })

      .addCase(BusinessEdit.pending, (state, action) => {
        state.editLoading = true;
        state.alertError = false;
      })
      .addCase(BusinessEdit.fulfilled, (state, action) => {
        state.responseData = action.payload;
        state.editLoading = false;
        state.alertError = false;
      })
      .addCase(BusinessEdit.rejected, (state, action) => {
        state.editLoading = false;
        state.responseData = [];
        state.errorEdit = "Something went error";
        state.alertError = true;
      })

      .addCase(getTableFilter.fulfilled, (state, action) => {
        state.tableFilterData = action.payload;
        state.alertError = false;
      })

      // userInfo List
      .addCase(userInfoListApi.pending, (state, action) => {
        state.userInfoListLoading = true;
        state.alertError = false;
      })
      .addCase(userInfoListApi.fulfilled, (state, action) => {
        state.userInfoListData = action.payload;
        state.userInfoListLoading = false;
        state.ldapSyncdata = [];
        state.ldapSyncdataFulFill = false;
        state.alertError = false;
      })
      .addCase(userInfoListApi.rejected, (state, action) => {
        state.userInfoListLoading = false;
        state.userInfoListData = [];
        state.ldapSyncdata = [];
        state.ldapSyncdataFulFill = false;
        state.alertError = true;
      })

      .addCase(userInfoCountApi.pending, (state, action) => {
        state.userInfoCountLoading = true;
        state.alertError = false;
      })
      .addCase(userInfoCountApi.fulfilled, (state, action) => {
        state.userInfoCountData = action.payload;
        state.userInfoCountLoading = false;
        state.alertError = false;
      })
      .addCase(userInfoCountApi.rejected, (state, action) => {
        state.userInfoCountLoading = false;
        state.userInfoCountData = [];
        state.alertError = true;
      })

      // serverInfo List
      .addCase(serverInfoListApi.pending, (state, action) => {
        state.serverInfoListLoading = true;
        state.alertError = false;
      })
      .addCase(serverInfoListApi.fulfilled, (state, action) => {
        state.serverInfoListData = action.payload;
        state.serverInfoListLoading = false;
        state.alertError = false;
      })
      .addCase(serverInfoListApi.rejected, (state, action) => {
        state.serverInfoListLoading = false;
        state.serverInfoListData = [];
        state.alertError = true;
      })

      // cloudAccount List
      .addCase(cloudAccountListApi.pending, (state, action) => {
        state.cloudAccountListLoading = true;
        state.alertError = false;
      })
      .addCase(cloudAccountListApi.fulfilled, (state, action) => {
        state.cloudAccountListData = action.payload;
        state.cloudAccountListLoading = false;
        state.alertError = false;
      })
      .addCase(cloudAccountListApi.rejected, (state, action) => {
        state.cloudAccountListLoading = false;
        state.cloudAccountListData = [];
        state.alertError = true;
      })

      .addCase(cloudAccountCountApi.pending, (state, action) => {
        state.cloudAccountCountLoading = true;
        state.alertError = false;
      })
      .addCase(cloudAccountCountApi.fulfilled, (state, action) => {
        state.cloudAccountCountData = action.payload;
        state.cloudAccountCountLoading = false;
        state.alertError = false;
      })
      .addCase(cloudAccountCountApi.rejected, (state, action) => {
        state.cloudAccountCountLoading = false;
        state.cloudAccountCountData = [];
        state.alertError = true;
      })
      // osLicenseConfig List
      .addCase(osLicenseConfigListApi.pending, (state, action) => {
        state.osLicenseConfigListLoading = true;
        state.alertError = false;
      })
      .addCase(osLicenseConfigListApi.fulfilled, (state, action) => {
        state.osLicenseConfigListData = action.payload;
        state.osLicenseConfigListLoading = false;
        state.alertError = false;
      })
      .addCase(osLicenseConfigListApi.rejected, (state, action) => {
        state.osLicenseConfigListLoading = false;
        state.osLicenseConfigListData = [];
        state.alertError = true;
      })

      .addCase(osLicenseConfigCountApi.pending, (state, action) => {
        state.osLicenseConfigCountLoading = true;
        state.alertError = false;
      })
      .addCase(osLicenseConfigCountApi.fulfilled, (state, action) => {
        state.osLicenseConfigCountData = action.payload;
        state.osLicenseConfigCountLoading = false;
        state.alertError = false;
      })
      .addCase(osLicenseConfigCountApi.rejected, (state, action) => {
        state.osLicenseConfigCountLoading = false;
        state.osLicenseConfigCountData = [];
        state.alertError = true;
      })

      .addCase(isLdapUserCheckAPI.pending, (state, action) => {
        state.isLdapUserLoading = true;
        state.alertError = false;
      })
      .addCase(isLdapUserCheckAPI.fulfilled, (state, action) => {
        state.isLdapUser = action.payload;
        state.isLdapUserLoading = false;
        state.alertError = false;
      })
      .addCase(isLdapUserCheckAPI.rejected, (state, action) => {
        state.isLdapUserLoading = false;
        state.isLdapUser = [];
        state.alertError = true;
      })

      .addCase(ldapSyncAPI.pending, (state, action) => {
        state.ldapSyncLoading = true;
        state.alertError = false;
      })
      .addCase(ldapSyncAPI.fulfilled, (state, action) => {
        state.ldapSyncdata = action.payload;
        state.ldapSyncdataFulFill = true;
        state.ldapSyncLoading = false;
        state.alertError = false;
      })
      .addCase(ldapSyncAPI.rejected, (state, action) => {
        state.ldapSyncLoading = false;
        state.ldapSyncdata = [];
        state.alertError = true;
      })

      .addCase(userSearchList.pending, (state, action) => {
        state.userSearchListLoading = true;
        state.alertError = false;
      })
      .addCase(userSearchList.fulfilled, (state, action) => {
        state.userSearchListData = action.payload;
        state.userSearchListLoading = false;
        state.alertError = false;
      })
      .addCase(userSearchList.rejected, (state, action) => {
        state.userSearchListLoading = false;
        state.userSearchListData = [];
        state.alertError = true;
      })

      .addCase(saveReviewerConfiguration.pending, (state, action) => {
        state.saveReviewerConfigurationLoading = true;
        state.alertError = false;
      })
      .addCase(saveReviewerConfiguration.fulfilled, (state, action) => {
        state.saveReviewerConfigurationData = action.payload;
        state.saveReviewerConfigurationLoading = false;
        state.alertError = false;
      })
      .addCase(saveReviewerConfiguration.rejected, (state, action) => {
        state.saveReviewerConfigurationLoading = false;
        state.saveReviewerConfigurationData = [];
        state.alertError = true;
      })

      .addCase(reviewersList.pending, (state, action) => {
        state.reviewersListLoading = true;
        state.alertError = false;
      })
      .addCase(reviewersList.fulfilled, (state, action) => {
        state.reviewersListData = action.payload;
        state.reviewersListLoading = false;
        state.alertError = false;
      })
      .addCase(reviewersList.rejected, (state, action) => {
        state.reviewersListLoading = false;
        state.reviewersListData = [];
        state.alertError = true;
      })

      .addCase(reviewConfiguration.pending, (state, action) => {
        state.reviewConfigurationLoading = true;
        state.alertError = false;
      })
      .addCase(reviewConfiguration.fulfilled, (state, action) => {
        state.reviewConfigurationData = action.payload;
        state.reviewConfigurationLoading = false;
        state.alertError = false;
      })
      .addCase(reviewConfiguration.rejected, (state, action) => {
        state.reviewConfigurationLoading = false;
        state.reviewConfigurationData = [];
        state.alertError = true;
      })

      .addCase(getServerConfigDetails.pending, (state, action) => {
        state.serverConfigLoading = true;
        state.alertError = false;
      })
      .addCase(getServerConfigDetails.fulfilled, (state, action) => {
        state.serverConfigData = action.payload;
        state.serverConfigLoading = false;
        state.alertError = false;
      })
      .addCase(getServerConfigDetails.rejected, (state, action) => {
        state.serverConfigLoading = false;
        state.serverConfigData = [];
        state.alertError = true;
      })

      .addCase(SaveServerConfig.pending, (state, action) => {
        state.serverConfigSaveDataLoading = true;
        state.alertError = false;
      })
      .addCase(SaveServerConfig.fulfilled, (state, action) => {
        state.serverConfogSaveData = action.payload;
        state.serverConfigSaveDataLoading = false;
        state.alertError = false;
      })
      .addCase(SaveServerConfig.rejected, (state, action) => {
        state.serverConfigSaveDataLoading = false;
        state.serverConfogSaveData = [];
        state.alertError = true;
      })

      .addCase(getProjectList.pending, (state, action) => {
        state.projectListDataLoading = true;
        state.alertError = false;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.projectListData = action.payload;
        state.projectListDataLoading = false;
        state.alertError = false;
      })
      .addCase(getProjectList.rejected, (state, action) => {
        state.projectListDataLoading = false;
        state.projectListData = [];
        state.alertError = true;
      })
      .addCase(getGitlabProjectList.pending, (state, action) => {
        state.GitlabprojectListDataLoading = true;
        state.alertError = false;
      })
      .addCase(getGitlabProjectList.fulfilled, (state, action) => {
        state.GitlabprojectListData = action.payload;
        state.GitlabprojectListDataLoading = false;
        state.alertError = false;
      })
      .addCase(getGitlabProjectList.rejected, (state, action) => {
        state.GitlabprojectListDataLoading = false;
        state.GitlabprojectListData = [];
        state.alertError = true;
      })

      //SonarQube
      .addCase(getSonarProjectListAPI.pending, (state, action) => {
        state.getSonarProjectListLoading = true;
        state.alertError = false;
      })
      .addCase(getSonarProjectListAPI.fulfilled, (state, action) => {
        state.getSonarProjectListData = action.payload;
        state.getSonarProjectListLoading = false;
        state.alertError = false;
      })
      .addCase(getSonarProjectListAPI.rejected, (state, action) => {
        state.getSonarProjectListLoading = false;
        state.getSonarProjectListData = [];
        state.alertError = true;
      })

      //ExportCSV
      .addCase(exportCmdbAppConfigCSV.pending, (state, action) => {
        state.exportCSVListLoading = true;
        state.alertError = false;
      })
      .addCase(exportCmdbAppConfigCSV.fulfilled, (state, action) => {
        state.exportCSVListLoading = false;
        state.alertError = false;
      })
      .addCase(exportCmdbAppConfigCSV.rejected, (state, action) => {
        state.exportCSVListLoading = false;
        state.exportCSVData = [];
        state.alertError = true;
      })

      //Import device csv

      .addCase(ImportCmdbDevices.pending, (state, action) => {
        state.ImportCmdbDevicesData = "";
        state.ImportCmdbDevicesDataLoading = true;
      })
      .addCase(ImportCmdbDevices.fulfilled, (state, action) => {
        state.ImportCmdbDevicesData = action.payload;
        state.ImportCmdbDevicesDataLoading = false;
      })
      .addCase(ImportCmdbDevices.rejected, (state, action) => {
        state.ImportCmdbDevicesDataLoading = false;
        state.ImportCmdbDevicesData = "";
        state.ImportCmdbDevicesError = "Something went wrong";
      })

      //Download template csv

      .addCase(downloadTemplate.pending, (state) => {
        state.templateLoading = true;
        state.templateError = null;
      })
      .addCase(downloadTemplate.fulfilled, (state) => {
        state.templateLoading = false;
      })
      .addCase(downloadTemplate.rejected, (state, action) => {
        state.templateLoading = false;
        state.templateError = action.payload;
      });
  },
});

export const {
  setCmdbId,
  resetDataSave,
  resetresponseData,
  resetldapSyncStatus,
  setalertError,
} = CMDBSlice.actions;
export default CMDBSlice.reducer;
